/**
 * Removes month-related tokens from a format string.
 */
export function removeMonthFromFormat(format: string) {
  return format.replace(/(Mo|Lo|M|L)+/g, '');
}
